import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { CheckList } from '../model/check-list';

@Injectable({
    providedIn: 'root'
  })
  export class CheckListService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    getCheckListBysubitemid(subItemId) 
    {
      return this._restClientService.load<CheckList[]>('check-list/check-lists-by-subitemid/'+subItemId);
    }

    add(checkList: CheckList) {
      return this._restClientService.save<CheckList>('check-list/add-check-list', checkList);
    }

}      

    